'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { reloadForEditorDocumentPolicy } from '@/lib/editorDocumentPolicy'

/**
 * Keeps route-specific editor response headers aligned with the active route.
 * Next.js client navigation cannot update document policies, so both entering
 * and leaving `/p/...` require one real document navigation.
 */
export function EditorDocumentPolicyBoundary() {
  const pathname = usePathname()

  useEffect(() => {
    reloadForEditorDocumentPolicy(pathname)
  }, [pathname])

  return null
}
